import { Password } from '@eventbrite/eds-password';
import { gettext } from '@eventbrite/i18n';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import React from 'react';

const PasswordField = ({
    shouldShowStrengthMeter,
    requiredPassword,
    isStatic,
    autoFocus,
    onIconClick,
    onChange,

    value,

    field,
    form: { errors, touched },
}: any) => {
    const style = isStatic ? 'static' : 'dynamic';
    const shouldShowErrors = touched.password && !!errors.password;

    // Formik field overrides onChange, using keyUp in this implementation
    const _handleKeyUp = (props: any) => {
        onChange?.(props);
    };

    //When user clicks on View Password
    const _handleIconClick = () => {
        onIconClick?.();
    };
    let passwordMeter = null;
    if (shouldShowStrengthMeter) {
        const PasswordStrengthMeter = loadable(
            () => import('@eventbrite/eds-strength-meter'),
            {
                resolveComponent: (component: any) =>
                    component.PasswordStrengthMeter,
            },
        );
        passwordMeter = <PasswordStrengthMeter inputPassword={value} />;
    }

    return (
        <div>
            <Password
                name="password"
                id="password"
                required={requiredPassword}
                autoFocus={autoFocus}
                label={gettext('Password')}
                data-testid="auth-lib-password-field"
                style={style}
                bottomSpacing={0}
                field={field}
                onKeyUp={_handleKeyUp}
                onIconClick={_handleIconClick}
                value={value}
                hasError={shouldShowErrors}
                annotationNote={shouldShowErrors && errors?.password}
            />

            {passwordMeter}
        </div>
    );
};

PasswordField.propTypes = {
    shouldShowStrengthMeter: PropTypes.bool,
    requiredPassword: PropTypes.bool,
    onRememberMeChange: PropTypes.func,
    isStatic: PropTypes.bool,

    /* Needed to force autofocus on the PW reset form */
    autoFocus: PropTypes.bool,

    onChange: PropTypes.func,
    onIconClick: PropTypes.func,

    value: PropTypes.string,
};

export default PasswordField;
